import { apiSlice } from '../../../store/api/apiSlice';
import type {
  CalendarAccount,
  CalendarAccountsResponse,
  ConnectICloudCalendarRequest,
  DisconnectCalendarAccountRequest,
  UpdateConflictCalendarSelectionRequest,
} from '../types';

export const calendarSettingsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCalendarAccounts: builder.query<CalendarAccountsResponse, void>({
      query: () => '/calendar/accounts',
      providesTags: ['CalendarSettings'],
    }),
    updateConflictCalendarSelection: builder.mutation<void, UpdateConflictCalendarSelectionRequest>(
      {
        query: (body) => ({
          url: '/calendar/conflict-selections',
          method: 'PUT',
          body,
        }),
        invalidatesTags: ['CalendarSettings'],
      }
    ),
    disconnectCalendarAccount: builder.mutation<void, DisconnectCalendarAccountRequest>({
      query: ({ provider, connection_id }) => ({
        url: `/calendar/accounts/${encodeURIComponent(connection_id)}?provider=${encodeURIComponent(provider)}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CalendarSettings'],
    }),
    connectICloudCalendar: builder.mutation<CalendarAccount, ConnectICloudCalendarRequest>({
      query: (body) => ({
        url: '/calendar/accounts/icloud-calendar',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CalendarSettings'],
    }),
  }),
});

export const {
  useConnectICloudCalendarMutation,
  useDisconnectCalendarAccountMutation,
  useGetCalendarAccountsQuery,
  useUpdateConflictCalendarSelectionMutation,
} = calendarSettingsApi;
